import type { IconSvgObject } from './types';

const DollarSignIcon: IconSvgObject = [
  ["path", { d: "M17.5 8.62963C17.5 6.62504 15.0376 5 12 5C8.96243 5 6.5 6.62504 6.5 8.62963C6.5 10.6342 8 11.7407 12 11.7407C16 11.7407 18 12.7778 18 15.3704C18 17.963 15.5 19 12 19C8.5 19 6 17.5 6 15.5", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M12 3V21", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "1" }]
];

export default DollarSignIcon;
